import {
  queryOptions,
  useMutation,
  useSuspenseQuery,
} from "@tanstack/react-query";
import type {
  GuardrailApp,
  GuardrailTestPayload,
  UpdateGuardrailSettingsPayload,
} from "@/lib/http/guardrails";
import { api } from "@/lib/http";

export function guardrailAppsQueryOptions() {
  return queryOptions({
    queryKey: ["guardrails", "apps"],
    queryFn: () => api.guardrails.getApps(),
  });
}

export function useGuardrailApps() {
  return useSuspenseQuery(guardrailAppsQueryOptions());
}

export function guardrailFeaturesQueryOptions(app: GuardrailApp) {
  return queryOptions({
    queryKey: ["guardrails", "features", app],
    queryFn: () => api.guardrails.getFeatures(app),
  });
}

export function useGuardrailFeatures(app: GuardrailApp) {
  return useSuspenseQuery(guardrailFeaturesQueryOptions(app));
}

export function useUpdateGuardrailSettings() {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: number;
      payload: UpdateGuardrailSettingsPayload;
    }) => api.guardrails.updateSettings(id, payload),
  });
}

export function guardrailCatalogQueryOptions() {
  return queryOptions({
    queryKey: ["guardrails", "catalog"],
    queryFn: () => api.guardrails.getCatalog(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useTestGuardrails() {
  return useMutation({
    mutationFn: (payload: GuardrailTestPayload) =>
      api.guardrails.testGuardrails(payload),
  });
}
